import { render } from "./pediatric_visit.vue?vue&type=template&id=640c8529&scoped=true"
import script from "./pediatric_visit.vue?vue&type=script&lang=js"
export * from "./pediatric_visit.vue?vue&type=script&lang=js"

import "./pediatric_visit.vue?vue&type=style&index=0&id=640c8529&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640c8529"]])

export default __exports__